<!-- Can't find any use for this after angular upgrade -->
<!-- <div id="top-of-page"></div> -->

<div class="flex h-screen w-full overflow-hidden">
  <!-- Sidebar — PrimeNG Drawer (persistent on desktop / full-width toggle on mobile) and not rendered at all when opened from POS (isApp: embedded from POS) -->
  @if (!isApp && !hideMainNav) {
    <p-drawer
      [(visible)]="navVisible"
      position="left"
      [modal]="false"
      [dismissible]="false"
      [closeOnEscape]="isSmallScreen()"
      [showCloseIcon]="false"
      [transitionOptions]="isSmallScreen() ? '300ms cubic-bezier(0, 0, 0.2, 1)' : '0ms'"
      [style]="{ width: drawerWidth, minWidth: drawerWidth, maxWidth: drawerWidth, height: '100%' }"
      [styleClass]="
        '!rounded-none !p-0 !overflow-hidden bg-sb-surface-primary ' +
        (isSmallScreen()
          ? 'sb-drawer-mobile !max-w-none w-screen border-none'
          : (getDrawerStatus() ? 'sb-drawer-expanded ' : 'sb-drawer-collapsed ') +
            'border-r border-sb-border-secondary')
      "
    >
      <ng-template #headless>
        <div class="flex h-full flex-[1_1_100%] flex-col">
          <client-profile
            (sideBarSizeChanged)="emitBarChanged()"
            (uploadHandler)="uploadOpen($event)"
            (showStoresHandler)="setShowStores($event)"
            [supportedLanguages]="supportedLanguages()"
            [currentClient]="selectedCompany()"
            [activeProgress]="showProgress()"
            [isSmallScreen]="isSmallScreen()"
            (emitLang)="toggleMenu($event)"
            #clientProfile
          >
          </client-profile>

          <shopbox-list
            class="min-h-0 flex-auto overflow-y-auto overflow-x-hidden"
            [activeProgress]="showProgress()"
            (getActiveLinkName)="setRouterName($event)"
            [minNav]="!getDrawerStatus()"
            [setNativeApp]="isNativeApp"
            #shopboxList
          >
          </shopbox-list>

          <!-- Sidebar footer: logo + client ID -->
          <div
            class="flex w-full shrink-0 flex-col items-center border-t border-sb-border-secondary bg-sb-surface-primary"
            [ngClass]="getDrawerStatus() ? 'gap-1.5 px-5 py-4' : 'px-2 py-3'"
          >
            @if (getDrawerStatus()) {
              <img
                src="../../assets/core/Nav-logo.png"
                alt="shopbox logo"
                class="h-4 w-[106px] object-contain"
              />
            }
            @if (selectedCompany() && selectedCompany()?.uid) {
              <div
                class="w-fit max-w-full cursor-pointer break-words text-center font-medium text-sb-text-secondary transition-colors hover:text-sb-text-primary"
                [ngClass]="getDrawerStatus() ? 'text-sm leading-[18px]' : 'text-[11px] leading-4'"
                [cdkCopyToClipboard]="selectedCompany()?.uid?.toString() ?? ''"
                (cdkCopyToClipboardCopied)="onClientIdCopied($event)"
                [pTooltip]="translatedClickToCopyClientId()"
                tooltipPosition="right"
              >
                {{ translatedClientId() + ': ' + selectedCompany()?.uid }}
              </div>
            }
          </div>
        </div>
      </ng-template>
    </p-drawer>
  }

  <!-- Store switcher panel -->
  <ng-template #storeSwitcherTpl>
    <sb-store-switcher
      [companies]="companiesFiltered()"
      [selectedUid]="selectedCompany()?.uid ?? null"
      [searchValue]="companySearch()"
      [isSearching]="isSearching()"
      [isLoadingMore]="isLoadingMore()"
      [placeholderText]="translatedSearch()"
      [refreshLabel]="translatedRefreshLabel()"
      [listLabel]="translatedStoresList()"
      (searchChange)="searchInCompanies($event)"
      (searchEnter)="searchInCompanies(companySearch())"
      (searchClear)="resetSearchInCompanies($event)"
      (refreshed)="refreshStores()"
      (storeSelected)="selectStore($event.client, $event.uid)"
      (scrolled)="onScroll($event)"
    >
    </sb-store-switcher>
  </ng-template>

  <!-- Main content: vertical scroll only. Horizontal overflow is handled per module container (tables/content wrappers) so page-header behavior stays module-controlled. -->
  <div
    class="flex min-w-0 flex-1 flex-col overflow-y-auto bg-sb-surface-primary-active transition-all duration-300"
    [style.margin-left]="contentMarginLeft"
  >
    <!-- Pull-to-refresh indicator -->
    @if (getRefreshBarVisibility()) {
      @if (startTouch) {
        <div class="my-5 h-full w-full text-center">
          <div class="mx-auto h-[70px] w-[70px] rounded-full bg-sb-surface-primary shadow-md">
            @if (endTouch) {
              <i
                class="pi pi-arrow-down z-[1] mt-2.5 block transition-none"
                [style.transform]="'rotate(' + rotateArrow + 'deg)'"
              >
              </i>
            }
            @if (!endTouch) {
              <p-progress-spinner [style]="{ width: '70px', height: '70px' }"></p-progress-spinner>
            }
          </div>
        </div>
      }
      <div
        id="drag-handler"
        class="h-6 cursor-move bg-sb-surface-primary-active text-center text-sb-text-primary"
        pTooltip="Drag to refresh"
        [tooltipDisabled]="isTouchDevice || isApp"
        shopboxPullDown
        (topMove)="getTopMoveNum($event)"
        (rotateArrow)="getRotateArrow($event)"
        (onPull)="onPull($event)"
        [trackProgress]="showProgress()"
        (startTouch)="getStartTouch($event)"
        (endTouch)="getEndTouch($event)"
      >
        <i id="drag-handler-hand" class="pi pi-grip-lines cursor-move"></i>
      </div>
    }

    <shopbox-progress-bar></shopbox-progress-bar>

    @if (getTrialToolbarStatus()) {
      <shopbox-trial-toolbar [days]="trialDaysLeft"></shopbox-trial-toolbar>
    }

    <!-- Counter POS sticky header: StorageService flags set/cleared by counter-screen container and only used there -->
    @if (getHeaderToolbarVisibility() && (getBreadCrumbsNav() || getStaffProfile())) {
      <div
        class="sticky top-0 z-[998] flex min-h-16 w-full items-center gap-1 bg-sb-surface-primary-active px-2 text-sb-text-primary"
        [class.mt-2.5]="getTrialToolbarStatus()"
      >
        <div class="flex min-h-0 min-w-0 flex-[1_1_100%] items-center justify-center">
          @if (getBreadCrumbsNav()) {
            <shopbox-bread-crumb-nav class="flex w-full max-w-full items-center justify-center">
            </shopbox-bread-crumb-nav>
          }
        </div>
        @if (getStaffProfile()) {
          <shopbox-staff-profile
            class="flex flex-auto items-center justify-end"
            (logout)="navListMenu()?.logout()"
          >
          </shopbox-staff-profile>
        }
      </div>
    }

    @if (!isAccessBlocked()) {
      <router-outlet
        (activate)="onActivate($event)"
        (deactivate)="onDeactivate($event)"
      ></router-outlet>
    } @else {
      <shopbox-permission [grants]="true"></shopbox-permission>
    }
  </div>
</div>

<sb-shopbox-ai-panel></sb-shopbox-ai-panel>
